import axios from 'axios';

import { IModelCSystemParameter } from '@/shared/model/model-c-system-parameter.model';

const baseApiUrl = 'api/model-c-system-parameters';

export default class ModelCSystemParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelCSystemParameter): Promise<IModelCSystemParameter> {
    return new Promise<IModelCSystemParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelCSystemParameter> {
    return new Promise<IModelCSystemParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
